import { render } from "./DashboardClient.vue?vue&type=template&id=aeca20c0"
import script from "./DashboardClient.vue?vue&type=script&lang=js"
export * from "./DashboardClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__